import { ASSET_UPLOAD_ERRORS, ITEM_UPLOAD_STATUS } from 'src/services/DirectFilesUploaderCoordinator';
import { IconProps } from '@ui/components/Icon/Icon';
import { ERROR, SUCCESS } from 'src/styles/colors';
import AssetUpload from 'src/entities/assetUpload';
import { Upload, UploadStatus } from './types';

export const hasFailed = ( upload: Upload ): boolean => (
	upload.status === ITEM_UPLOAD_STATUS.FAILED
);

export const hasSucceded = ( upload: Upload ): boolean => (
	upload.status === ITEM_UPLOAD_STATUS.SUCCEEDED
);

export const isUploading = ( upload: Upload ): boolean => (
	[
		ITEM_UPLOAD_STATUS.WAITING,
		ITEM_UPLOAD_STATUS.UPLOADING
	].includes( upload.status )
)

type IconConfig = { icon: IconProps[ 'icon' ], color?: string };
const ICON_CONFIG_BY_STATUS: Partial<Record<UploadStatus, IconConfig>> = {
	[ ITEM_UPLOAD_STATUS.ABORTED ]: { icon: 'remove_circle' },
	[ ITEM_UPLOAD_STATUS.FAILED ]: { icon: 'error', color: ERROR },
	[ ITEM_UPLOAD_STATUS.CREATING_ASSET ]: { icon: 'access_time' },
	[ ITEM_UPLOAD_STATUS.SUCCEEDED ]: { icon: 'check_circle', color: SUCCESS }
};

const isAssetUpload = ( upload: Upload ): upload is AssetUpload => !upload.isFolderUpload;

const isReviewerDuplicate = ( upload: Upload ): boolean => (
	hasFailed( upload ) && isAssetUpload( upload )
		&& upload.errorName === ASSET_UPLOAD_ERRORS.REVIEWER_DUPLICATE_ASSET
);

export const iconConfigFor = ( upload: Upload ): IconConfig | undefined => {
	if ( isReviewerDuplicate( upload ) ) { return { icon: 'remove_circle', color: 'var(--color-feedback-warning)' }; }
	return ICON_CONFIG_BY_STATUS[ upload.status as UploadStatus ];
};

type StatusConfig = { text: string, className?: string };
const STATUS_CONFIG_BY_STATUS: Partial<Record<UploadStatus, StatusConfig>> = {
	[ ITEM_UPLOAD_STATUS.ABORTED ]: { text: 'Canceled', className: 'canceled' },
	[ ITEM_UPLOAD_STATUS.FAILED ]: { text: 'Error uploading', className: 'failed' },
	[ ITEM_UPLOAD_STATUS.CREATING_ASSET ]: { text: '' },
	[ ITEM_UPLOAD_STATUS.SUCCEEDED ]: { text: '' }
};

export const statusConfigFor = ( upload: Upload ): StatusConfig => {
	if ( isUploading( upload ) ) { return { text: upload.progressText }; }
	if ( hasSucceded( upload ) ) { return { text: upload.description }; }
	if ( isReviewerDuplicate( upload ) ) { return { text: 'Duplicated Asset', className: 'canceled' }; }

	return STATUS_CONFIG_BY_STATUS[ upload.status as UploadStatus ] || { text: '' };
};
